import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, clsx } from '@a-type/ui';
import { TopographyBackground } from './TopographyBackground.js';
import cls from './TopographyButton.module.css';
export const TopographyButton = ({ children, className, disableTopography, wrapperClassName, ...props }) => {
    return (_jsxs(Button, { emphasis: "primary", ...props, className: clsx(cls.root, className), children: [!props.disabled && !props.visuallyDisabled && !disableTopography && (_jsx(TopographyBackground, { className: cls.bg })), _jsx("div", { className: clsx(cls.content, wrapperClassName), children: children })] }));
};
//# sourceMappingURL=TopographyButton.js.map